export const AZURE_AD = {
  clientId: "b154f51b-0bf6-460e-b9d8-3d67ac3561fa",
  tenantId: "e938248c-a89f-4e06-818c-e68c1f48150d",
  authority: "https://login.microsoftonline.com/e938248c-a89f-4e06-818c-e68c1f48150d",
};

export const BACKEND_API = {
  // baseUrl: "http://localhost:8000",
  baseUrl: "https://www.mai-backend-service.com/",
  prefix: "/",
};